
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38 1H10a9 9 0 00-9 9v20a9 9 0 009 9h28a9 9 0 009-9V10a9 9 0 00-9-9z","stroke":"#218665","stroke-width":"2"}}),_c('path',{attrs:{"d":"M22.13 31H15v-9l2.306-1.42A4.308 4.308 0 0123.5 22.5l.979 5.871c.014.086.021.173.021.26A2.37 2.37 0 0122.13 31z","fill":"#218665"}}),_c('path',{attrs:{"d":"M8.37 31h7.13v-9l-2.306-1.42A4.308 4.308 0 007 22.5l-.979 5.871a1.579 1.579 0 00-.021.26A2.37 2.37 0 008.37 31zM15 20a5 5 0 100-10 5 5 0 000 10zM40.5 14h-13a1.5 1.5 0 000 3h13a1.5 1.5 0 000-3zM37.5 19h-10a1.5 1.5 0 000 3h10a1.5 1.5 0 000-3zM40.5 24h-13a1.5 1.5 0 000 3h13a1.5 1.5 0 000-3z","fill":"#218665"}})])
          )
        }
      }
    